/**
 * Profile completion. Reachable only while the session is `incomplete` — a valid token with no local
 * profile row — because that is the only state the flow can act on.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

import { sessionRedirectFrom } from '~/entities/session';
import { ProfileCompletionScreen } from '~/pages/complete-profile';

export const Route = createFileRoute('/complete-profile')({
  beforeLoad: () => {
    const destination = sessionRedirectFrom('/complete-profile');
    // `throw: true` makes `redirect` raise the router's own Response itself. A bare `throw
    // redirect(...)` throws a non-Error, which is exactly what `only-throw-error` is there to catch.
    if (destination !== null) redirect({ to: destination, replace: true, throw: true });
  },
  component: ProfileCompletionScreen,
});
